import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Textfield from "@atlaskit/textfield";
import { setCurrentWizardData } from "../../../../../../redux/actions/wizardActions";

const GenericWebRequest = () => {
  const currentData = useSelector((state) => state.wizard.currentData);
  const dispatch = useDispatch();

  const onChange = (fieldName) => (e) => {
    const updatedData = {
      ...currentData,
      [fieldName]: e.target.value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };

  useEffect(() => {
   
  }, [currentData]);

   

  return (
    <> 
      Make a GET request to URL:
      <Textfield
        name="url"
        value={currentData?.url ? currentData?.url : ""}
        onChange={onChange("url")}
      />
    
   </>
  );
};
export default GenericWebRequest;
